module.exports = __webpack_public_path__ + "img/ycdpIconac.36a117e0.png";